import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyDv4iRPMTD0FFREH22p7L4t5km_wd68t9c",
  authDomain: "uygulama-e5dd5.firebaseapp.com",
  projectId: "uygulama-e5dd5",
  storageBucket: "uygulama-e5dd5.firebasestorage.app",
  messagingSenderId: "435381808656",
  appId: "1:435381808656:web:eaaf97dd4c7c1b61f1a495",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
// Uzman belgeleri Storage'a tasindi (users dokumaninda base64 DEGIL).
// Admin, storage.rules geregi admins/{uid} kaydi sayesinde okuyabilir.
export const storage = getStorage(app);